module.exports = __webpack_public_path__ + "static/media/portada_magnanime.50d04741.jpg";